import React from 'react';

// import { Container } from './styles';

function Shield({avatarurl, shieldurl,text, containerwidth="w-[100%]", textColor='text-[#fff] font-bold'}) {
  return (
                <div className={containerwidth} >
                    <div className='flex relative w-[100%] items-center justify-center'>
                        <div
                            style={{
                                width: '40%',
                                aspectRatio: '1/1',
                                position: 'absolute',
                                top: '25%',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                borderRadius: '100%',
                                overflow: 'hidden',
                                border: '1px solid #fff5',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 10
                            }}
                        >
                            <img 
                                style={{ minHeight: '125%', minWidth:'125%', objectFit: 'cover' }} 
                                src={avatarurl}
                            />
                        </div>

						 <div
                            style={{
                                width: '40%',
                                aspectRatio: '1/1',
                                position: 'absolute',
                                top: '48%',
                                left: '30%',
                                overflow: 'hidden',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                zIndex: 10
                            }}
                            className={`${textColor}`}
                        >
                            {text}
                        </div>
						
                        <img 
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
                            src={shieldurl} 
                        />
                    </div>
                </div>
  );
}

export default Shield;